export const CLOSED_SUBJECT_IDS = new Set([
  "385999b9-532a-4526-8ba4-40c86f47a0f2",
  "94ce3248-7a00-40be-b5f6-8c4f831ad526",
  "d2c5857d-4d6c-4e1d-aaa5-a6a0875cac40",
]);

export const getClosedSubjectIdBySlug = (subjectSlug, subjects = []) => {
  if (!subjectSlug) return null;

  const subject = subjects.find((item) => item?.slug === subjectSlug);
  return CLOSED_SUBJECT_IDS.has(subject?.id || "") ? subject.id : null;
};
